import axios from "axios";
import crudApi from "./crudApi";
import {API_COMPANIES, API_COMPANIES_WITHOUT_DEFAULT_DIRECTIVES} from '../api.js';

class Company extends crudApi {
    async create(data, options = {}) {
        return await axios.post(API_COMPANIES, data, options);
    }

    get(id, options = {}) {
        return axios.get(`${API_COMPANIES}/${id}`, options);
    }

    getQuantityOfCompaniesWithoutDefaultDirectives(options = {}) {
        return axios.get(`${API_COMPANIES_WITHOUT_DEFAULT_DIRECTIVES}`, options);
    }

    async edit(data, options = {}) {
        return await axios.patch(`${API_COMPANIES}/${data.id}`, data, options);
    }

    async remove(data, options = {}) {
        return await axios.delete(`${API_COMPANIES}/${data.id}`, options);
    }

    async getBuyerCompanyDetail(id, options = {}){
        return await axios.get(`${API_COMPANIES}/${id}/buyer_details`, options)
    }

    async getBuyerCompanyReport(id, options = {}){
        return await axios.get(`${API_COMPANIES}/${id}/buyer_report`, options)
    }

    async getBuyerCompanyRowReport(id, options = {}){
        return await axios.get(`${API_COMPANIES}/${id}/row_buyer_report`, options)
    }
};

export default new Company(API_COMPANIES);
